<template>
  <div id="app" v-loading="loading">
    <router-view name="agreement"></router-view>
    <router-view name="wechat"></router-view>
    <div class="loginMain" v-show="isLoginDom">
      <div class="mainTop">
        <div class="topRouter" v-show="isPass">
          <router-view name="login"></router-view>
          <div class="other flex">
            <router-link to="/agreement" class="agreement" tag="a" target="_blank" v-show="isAgreement">用户协议
            </router-link>
            <a></a>
            <span>
              <router-link to="/">
                <a href="javascript:void(0);" class="loginA" v-show="isLogin">登录</a>
              </router-link>
               <router-link to="/register" v-if="allowedRegister">
                <a href="javascript:void(0);" class="register" v-show="isRegister">注册</a>
              </router-link>
              <router-link to="/forget" v-if="allowedRegister">
                <a href="javascript:void(0);" class="forget" v-show="isForget">忘记密码?</a>
              </router-link>
            </span>
          </div>
          <div class="otherLogin" v-show="isOther"  v-if="allowedRegister">
            <div class="otherLine">
              <span>其它方式登陆</span>
            </div>
            <div class="otherBtn">
              <a href="javascript:void(0);" @click="openCode">
                <svg class="svgIcon" aria-hidden="true">
                  <use xlink:href="#iconxingzhuang2"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="wachatCode" v-show="isWeChat">
          <!-- <h3>请使用微信扫描二维码登录</h3> -->
          <!-- <p>“时空线统一登陆系统”</p> -->
          <a href="javascript:;" @click="closeCode"></a>
          <div class="codeDiv" id="codeDiv"></div>
        </div>
      </div>
      <div class="mainBot">
        <!--        <p>中国最大的统一登录平台，便捷、安全！</p>-->
        <!--<p class="address">华智帆科技发展有限公司版权所有©2016-2019 网站备案/许可证号：冀ICP备17023427号-1  地址:保定市竞秀区朝阳北大街源盛广场A座1705室</p>-->
        <!--<div>-->
        <!--<img src="https://img.alicdn.com/tfs/TB1q94TdQY2gK0jSZFgXXc5OFXa-20-20.png" alt="">-->
        <!--<span>冀ICP备17023427号</span>-->
        <!--</div>-->
      </div>
    </div>
    <div class="toast" v-show="toastCreat.show">
      <i class="iconfont toastTip" :class="toastCreat.className"></i>
      <span>{{ toastCreat.text }}</span>
      <i class="iconfont iconrrr closeToast" v-bind:time="toastCreat.time" @click="closeToast"></i>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import bus from '@/assets/bus.js'

export default {
  name: 'App',
  data() {
    return {
      loading: false,
      isLoginDom: true,
      isPass: true,
      isWeChat: false,
      isAgreement: true,
      isLogin: true,
      isOther: true,
      isRegister: true,
      isForget: true,
      toastCreat: {
        show: false,
        text: '',
        time: '5000',
        className: 'iconx',
        timer: function () {
        }
      },
      allowedRegister: true
    }
  },
  watch: {
    '$route': 'pageTips'
  },
  created: function () {
    if (window.location.href.indexOf("sso.shikongxian.com") < 0) {
      this.allowedRegister = false;
    }
    this.pageTips();
  },
  mounted: function () {
    var _this = this;
    bus.$on('openToast', msg => {
      _this.craetToast(msg.tips, msg.txt);
    })
    bus.$on('loadingopen', function () {
      _this.loading = true
    })
    bus.$on('loadingclose', function () {
      _this.loading = false
    })
  },
  methods: {
    pageTips() {
      this.isAgreement = false;
      this.isLogin = false;
      this.isRegister = false;
      this.isForget = false;
      this.isOther = true;
      // if(this.$route.name == 'agreement') this.isLoginDom = false; else this.isLoginDom = true;
      if (this.$route.name == '/') {
        this.isRegister = true;
        this.isForget = true;
      } else if (this.$route.name == 'register') {
        this.isLogin = true;
        this.isAgreement = true;
      } else if (this.$route.name == 'forget') {
        this.isLogin = true;
        this.isAgreement = true;
      } else if (this.$route.name == 'bindphone') {
        this.isOther = false;
      }
    },
    craetToast(tips, txt, time) {
      this.toastCreat.text = txt ? txt : '弹框5秒消失';
      this.toastCreat.time = time ? time : '5000';
      if (tips) this.toastCreat.className = 'iconv'; else this.toastCreat.className = 'iconx';
      this.toastCreat.show = true;
      this.timeClose();
    },
    openCreat() {
      this.toastCreat.show = ture;
    },
    timeClose() {
      var _this = this;
      this.toastCreat.timer = setTimeout(function () {
        _this.closeToast();
      }, _this.toastCreat.time);
    },
    closeToast() {
      this.toastCreat.show = false;
      clearInterval(this.toastCreat.timer);
    },
    getQueryString(name, url) {
      let reg = new RegExp("(^|&|/?)" + name + "=([^&]*)(&|$)", "i");
      if (url == null) {
        url = window.location.search.substr(1);
      }
      let r = url.match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },
    openCode() {
      document.getElementById('codeDiv').innerHTML = '';
      this.isPass = false;
      this.isWeChat = true;
      let redirectUri = this.getQueryString("redirect_uri");
      let redirectUri1 = this.getQueryString("redirect_uri", redirectUri);
      redirectUri = redirectUri1 == null ? redirectUri : redirectUri1;

      redirectUri = redirectUri == null ? this.Global.baseApi + "/info.html" : redirectUri;

      axios.get(this.Global.baseApi + "/anon/api/client?client_id=" + this.getQueryString("client_id", this.getQueryString("redirect_uri")))
        .then(data => {
          try {
            var weixinPcAppId = data.body.data.weixinPcAppId;
          } catch (err) {
            console.log(err);
          }
          if (weixinPcAppId == null) {
            weixinPcAppId = "wxbe842b1ee9c726a2";
          }
          let wx_redirectUri = "https%3a%2f%2fsso.shikongxian.com%2fweixinpcscan%3ffrom%3dweixinpcscan%26weixinappid%3d" + weixinPcAppId
            + "%26redirect_uri%3d" + encodeURIComponent(encodeURIComponent(redirectUri));
          console.log("11111111111111111111111");
          console.log(wx_redirectUri);

          var obj = new WxLogin({
            self_redirect: false,
            id: "codeDiv",
            appid: weixinPcAppId,
            scope: "snsapi_login",
            redirect_uri: wx_redirectUri,
            state: "tt",
            style: "",
            href: ""
          });
        })
    },
    closeCode() {
      this.isWeChat = false;
      this.isPass = true;
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #F4F3F4;
}

/*toast-start*/
.toast {
  top: 50%;
  left: 50%;
  color: #fff;
  z-index: 10;
  height: 62px;
  padding: 20px;
  font-size: 16px;
  cursor: default;
  position: absolute;
  line-height: 22px;
  border-radius: 2px;
  box-sizing: border-box;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, .6)
}

.toast span {
  padding: 0 15px 0 10px;
}

.toastTip {
  font-size: 16px;
  vertical-align: middle;
}

.closeToast {
  color: #d5d5d5;
  font-size: 12px;
  cursor: pointer;
  vertical-align: middle;
}

/*toast-end*/

.loginMain {
  width: 855px;
  margin: 115px auto 0;
}

.mainTop {
  width: 855px;
  min-height: 601px;
  padding-top: 85px;
  margin-bottom: 94px;
  position: relative;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 2px 10px 0 rgba(166, 166, 166, 0.50);
}

.topRouter {
  width: 351px;
  margin: 0 auto;
}

.mainBot {
  color: #666;
  font-size: 13px;
  text-align: center;
}

.mainBot .address {
  text-align: center;
  padding-bottom: 10px;
}

.mainBot > div img {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}

.topRouter .other {
  justify-content: space-between;
}

.topRouter .other .register {
  margin: 0 8px;
}

.otherLogin {
  padding-bottom: 28px;
}

.otherLine {
  height: 20px;
  margin: 23px 0;
  position: relative;
  text-align: center;
}

.otherLine:before {
  content: "";
  width: 351px;
  height: 1px;
  display: block;
  top: 10px;
  position: absolute;
  background-color: #CFCFCF;
}

.otherLine span {
  top: 0px;
  left: 50%;
  color: #999;
  padding: 0 4px;
  fonts-size: 12px;
  position: absolute;
  background-color: #fff;
  transform: translate(-50%, 0);
}

.otherBtn {
  text-align: center;
}

.wachatCode {
  width: 300px;
  margin: 0 auto;
}

.wachatCode h3 {
  color: #666;
  font-size: 24px;
}

.wachatCode p {
  color: #666;
  font-size: 16px;
  text-align: center;
  padding: 10px 0 20px;
}

.wachatCode a {
  top: 45px;
  right: 45px;
  width: 31px;
  height: 31px;
  position: absolute;
  background: url(../static/close.png) no-repeat center center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue